import { SkeletonBox, Space } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { useUmbrella } from '@modules-deprecated/app/umbrellas'

import { Scope } from '../../enums/scope'
import { CreditCard } from '../CreditCard'
import { DirectDebit } from '../DirectDebit'
import { ProtectedComponent } from '../ProtectedComponents'
import { AddPaymentMethod } from './elements/AddPaymentMethod'
import { PaymentMethodDetails } from './types'

interface PaymentMethodSelectionProps {
  paymentMethodDetails?: PaymentMethodDetails
  fullWidth?: boolean
  isLoading?: boolean
  isSubscribed?: boolean
  onAddPaymentClick: () => void
}

export const PaymentMethodSelection = ({
  paymentMethodDetails,
  fullWidth,
  isLoading,
  isSubscribed,
  onAddPaymentClick,
}: PaymentMethodSelectionProps): ReactElement => {
  const { umbrella } = useUmbrella()
  const { expirationDate, horizontal, isInvalid = false, label, detailType, issuer } = paymentMethodDetails || {}

  if (isLoading) {
    return (
      <>
        <Space size="s24" />
        <SkeletonBox fullWidth height={148} />
        <Space size="s24" />
      </>
    )
  }

  if (isSubscribed && paymentMethodDetails?.type === 'Card') {
    return (
      <CreditCard
        type={detailType}
        expirationDate={expirationDate}
        isInvalid={isInvalid}
        label={label}
        horizontal={horizontal}
      />
    )
  } else if (isSubscribed && paymentMethodDetails?.type === 'DirectDebit') {
    return <DirectDebit issuer={issuer} isInvalid={isInvalid} label={label} isHorizontal={horizontal} />
  }

  return (
    <ProtectedComponent scopes={Scope.OrganizationPaymentWrite} scopesCheckDisabled={!!umbrella?.id}>
      <AddPaymentMethod onAddPaymentClick={onAddPaymentClick} fullWidth={fullWidth} />
    </ProtectedComponent>
  )
}
